/**
 * Converts GraphQL header array to Record format for HTTP requests
 * @param headers - Array of key-value header objects from GraphQL
 * @returns Record<string, string> or undefined if no valid headers
 */
export const transformGraphQLHeaders = (
  headers: Array<{
    __typename?: 'HttpHeader'
    key: string
    value: string
  }>
): Record<string, string> | undefined => {
  if (!headers.length) return undefined

  const headersObj = headers.reduce((acc, header) => {
    if (header?.key && header?.value) {
      acc[header.key] = header.value
    }
    return acc
  }, {} as Record<string, string>)

  return Object.keys(headersObj).length > 0 ? headersObj : undefined
}

export const captureVideoFrame = (video: Record<string, any>) => {
  if (!video) {
    return null
  }

  const canvas = document.createElement('canvas') as HTMLCanvasElement
  canvas.width = video.videoWidth
  canvas.height = video.videoHeight
  canvas.getContext('2d').drawImage(video as HTMLVideoElement, 0, 0)

  const dataUri = canvas.toDataURL('image/png')
  const data = dataUri.split(',')[1]
  const mimeType = dataUri.split(';')[0].slice(5)

  const bytes = window.atob(data)
  const buffer = new ArrayBuffer(bytes.length)

  const arr = new Uint8Array(buffer)
  for (let i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i)
  }

  const blob = new Blob([arr], { type: mimeType })
  const videoDimensions = {
    width: video.videoWidth,
    height: video.videoHeight,
  }
  return {
    blob,
    imageUrl: dataUri,
    videoDimensions,
  }
}
